module.exports = __webpack_public_path__ + "static/about_pic1-6ccc92cca19fc2c966861228144c8cfd.png";